(function () {
  if (window.uxPopupInit) return;
  window.uxPopupInit = true;

  let dialog = null, titleEl = null, bodyEl = null;

  const build = () => {
    if (dialog || !document.body) return;
    dialog = document.createElement('dialog');
    dialog.className = 'ux-popup';
    dialog.innerHTML =
      '<div class="ux-popup__content">' +
        '<div class="ux-popup__header">' +
          '<h3 class="ux-popup__title"></h3>' +
          '<button type="button" class="ux-popup__close" data-ux-popup-close aria-label="Close"></button>' +
        '</div>' +
        '<div class="ux-popup__body"></div>' +
      '</div>';
    document.body.appendChild(dialog);
    titleEl = dialog.querySelector('.ux-popup__title');
    bodyEl = dialog.querySelector('.ux-popup__body');
  };

  const open = (trigger) => {
    build();
    if (!dialog) return;
    const title = trigger.getAttribute('data-ux-popup-title') || '';
    titleEl.textContent = title;
    titleEl.hidden = title === '';
    bodyEl.innerHTML = trigger.getAttribute('data-ux-popup-text') || '';
    if (typeof dialog.showModal === 'function') dialog.showModal();
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-ux-popup-close]')) {
      if (dialog) dialog.close();
      return;
    }
    if (dialog && e.target === dialog) {
      dialog.close();
      return;
    }
    const trigger = e.target.closest('[data-ux-popup-text]');
    if (trigger) open(trigger);
  });

  if (document.readyState !== 'loading') {
    build();
  } else {
    document.addEventListener('DOMContentLoaded', build);
  }
})();